import { render, staticRenderFns } from "./testRecord.vue?vue&type=template&id=73948ef1&scoped=true"
import script from "./testRecord.vue?vue&type=script&lang=js"
export * from "./testRecord.vue?vue&type=script&lang=js"
import style0 from "./testRecord.vue?vue&type=style&index=0&id=73948ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73948ef1",
  null
  
)

export default component.exports